import * as AT from './_types'
import fetchApi from '../../services/fetchApi'
import formatTimeAndDate from '../../services/call-log-helpers'


export const setDate = date => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_SET_DATE,
      date,
    })
  }
)

export const setCallLogFilter = callLogFilter => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_SET_CALL_LOG_FILTER,
      callLogFilter,
    })
  }
)

export const setPopoverPage = pageName => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_SET_POPOVER,
      pageName,
    })
  }
)

export const setSelectedTab = heading => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_SET_TAB,
      heading,
    })
  }
)

export const setNewContactInfo = (contactInfoType, value) => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_SET_NEW_CONTACT_INFO,
      contactInfoType,
      value,
    })
  }
)

export const setMatchingContacts = matchingContacts => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_SET_MATCHING_CONTACTS,
      matchingContacts,
    })
  }
)

export const clearCallData = () => (
  (dispatch) => {
    dispatch({
      type: AT.COREDIAL_CLEAR_CALL_DATA,
    })
  }
)

export const fetchCoredialCalls = (
  selectedDate,
  timeZone,
  changeDate,
  locationId = null,
  ) => (
  (dispatch) => {
    if (changeDate) {
      dispatch({ type: AT.COREDIAL_START_FETCHING })
      dispatch(setDate(selectedDate))
    }
    const startDate = selectedDate.format('YYYY-MM-DD')
    const endDate = selectedDate.clone().add(1, 'day').format('YYYY-MM-DD')
    const url = `/call_log${locationId ? `/${locationId}` : ''}?start_date=${startDate}&end_date=${endDate}&time_zone=${timeZone}`
    fetchApi(
      url,
      'GET',
    ).then((response) => {
      dispatch({
        type: AT.COREDIAL_SET_CALL_DATA,
        date: startDate,
        calls: formatTimeAndDate(response.calls),
      })
    })
  }
)

export const fetchCoredialCallsByPatient = (patientId, locationId = null) => (
  (dispatch) => {
    const url = `/patient_call_log/${patientId}${locationId ? `?location_id=${locationId}` : ''}`
    dispatch({ type: AT.COREDIAL_START_FETCHING })
    fetchApi(url, 'GET')
      .then((response) => {
        const newPatientCallData = formatTimeAndDate(response.calls)

        dispatch({
          type: AT.COREDIAL_SET_PATIENT_CALL_DATA,
          patientCallData: newPatientCallData,
        })
      })
  }
)

export const fetchContacts = () => (
  (dispatch) => {
    dispatch({ type: AT.COREDIAL_START_FETCHING_CONTACTS })
    fetchApi('/contacts', 'GET')
      .then((response) => {
        dispatch({
          type: AT.COREDIAL_SET_CONTACTS,
          contacts: response.contacts,
          conversionStats: response.conversion_stats,
        })
      })
  }
)

export const saveContact = contact => (
  (dispatch) => {
    const body = JSON.stringify(contact)
    return fetchApi('/contacts', 'POST', { body })
  }
)

export const searchContacts = (firstName, lastName, email) => (
  (dispatch) => {
    const url = `/call_log/contacts?first_name=${firstName}&last_name=${lastName}&email=${email}`
    return fetchApi(url, 'GET')
  }
)



// WEBPACK FOOTER //
// ./src/state/actions/call-log.js